import { motion } from "framer-motion";
import { HelpCircle, Link2, Plus, Trash2 } from "lucide-react";
import { Button } from "react-aria-components";

import type { BriefFile } from "../types";

import { Thumbnail } from "./Thumbnail";

type FilesSectionProps = {
  files: BriefFile[];
  links: string[];
};

export function FilesSection({ files, links }: FilesSectionProps) {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4 text-sm font-semibold">
          <button className="cursor-pointer text-text-secondary hover:text-text-primary">
            Download All
          </button>
          <button className="cursor-pointer text-fg-brand-primary hover:underline">
            Download selected
          </button>
        </div>
        <button className="cursor-pointer text-sm font-semibold text-text-error-primary hover:underline">
          Delete all
        </button>
      </div>

      <div className="flex flex-wrap gap-3">
        {files.map((file, i) => (
          <Thumbnail file={file} key={i} />
        ))}
      </div>

      <div className="flex flex-col gap-3">
        <span className="text-sm font-medium text-text-secondary">Links</span>
        <div className="flex items-center gap-2">
          <div className="relative flex flex-1 items-center rounded-lg border border-border-primary bg-bg-primary px-3.5 py-2.5">
            <input
              className="flex-1 bg-transparent text-sm text-text-primary outline-hidden placeholder:text-text-placeholder"
              placeholder="add your link here"
            />
            <HelpCircle className="size-4 text-fg-quaternary" />
          </div>
          <Button
            aria-label="Add link"
            className="flex size-[42px] shrink-0 cursor-pointer items-center justify-center rounded-lg border border-border-primary text-fg-brand-primary outline-hidden transition-colors hover:bg-bg-primary-hover"
          >
            <Plus className="size-5" />
          </Button>
        </div>

        <div className="flex flex-col gap-2">
          {links.map((link, i) => (
            <motion.div
              animate={{ opacity: 1, y: 0 }}
              className="flex items-center gap-3 rounded-lg border border-border-primary bg-bg-primary px-3.5 py-2.5"
              initial={{ opacity: 0, y: 4 }}
              key={i}
              transition={{ delay: i * 0.05 }}
            >
              <a
                className="flex-1 truncate text-sm text-fg-brand-primary hover:underline"
                href={link}
                rel="noreferrer"
                target="_blank"
              >
                {link}
              </a>
              <button
                aria-label="Delete link"
                className="cursor-pointer text-text-error-primary transition-transform hover:scale-110"
              >
                <Trash2 className="size-4" />
              </button>
              <button
                aria-label="Copy link"
                className="cursor-pointer text-fg-quaternary transition-transform hover:scale-110 hover:text-fg-brand-primary"
              >
                <Link2 className="size-4" />
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
